import { ENV, parseResponse, SUCCESSARRAY } from "../utils";

export class Auth {
    async login(data) {
        try {
        const url = `${ENV.API_URL}/${ENV.ENDPOINTS.AUTH.LOGIN}`;

        const params = {
            method: "POST",
            headers: {
            "Content-Type": "application/json",
            },
            body: JSON.stringify({
            email: data.email.trim().toLowerCase(),
            password: data.password,
            }),
        };

        const response = await fetch(url, params);
        const result = await parseResponse(response);

        if (!SUCCESSARRAY.includes(response.status)) {
            throw result;
        }

        return result;
        } catch (error) {
        throw error;
        }
    }
}